export default {
  auth(state) {
    return state.auth;
  },
  currentUser(state) {
    return state.currentUser;
  },
  isAdmin(state) {
    return state.user.isAdmin;
  },
};
